<template>
  <div>
    <span class="primary--text">Foto</span>
    <v-card @click="showModal = true" elevation="5" height="150" class="d-flex justify-center mt-2" v-if="!picture">
      <v-icon
          x-large
          color="primary"
      >
        mdi-camera
      </v-icon>
    </v-card>
    <v-card v-else elevation="5" height="150" class="d-flex justify-center">
      <v-img :src="picture"></v-img>
    </v-card>

    <swipe-modal
        v-model="showModal"
        contents-height="80vh"
        border-top-radius="16px"
        tip-color="text-cp-primary"
    >
      <div>
        <easy-camera v-model="picture" :mustApprove="true" @approve="approve($event)" :autoDetectMobile="true" fullscreen ref="camera">
        </easy-camera>
      </div>
    </swipe-modal>
  </div>
</template>

<script>
import swipeModal from '@takuma-ru/vue-swipe-modal';
import EasyCamera from 'easy-vue-camera';

export default {
  name: "CpCamera.vue",
  components: {
    swipeModal,
    EasyCamera
  },
  props: {
    label: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      showModal: false,
      picture: null
    }
  },
  methods: {
    approve($picture) {
      this.picture = $picture
      this.showModal = false

      let inputed = {}
      inputed[this.name] = $picture

      this.$emit('inputed', inputed)
    },
  },
}
</script>

<style>
.swipe-modal-takumaru-vue-swipe-modal .modal-background {
  width: 100%;
  height: 100%;
}
</style>